import { useQuery } from "react-query";
import axios from "../axios";

const useGetProducts = ({
  page = 1,
  limit = 10,
  search = "",
  id = "",
  sort,
  searchObject = {},
  onSuccess, // <-- allow callback
}) => {
  const query = useQuery(
    ["products", page, limit, search, sort, id, searchObject],
    async () => {
      const response = await axios.get(`/api/v2/product/seller`, {
        params: {
          page,
          limit,
          id,
          search,
          sort,
          ...(Object.keys(searchObject).length && { searchObject }),
        },
      });
      return response.data;
    },
    {
      keepPreviousData: false,
      staleTime: 0,
      onSuccess, // <-- call success callback
    }
  );

  return query;
};

export default useGetProducts;
